module.exports = __webpack_public_path__ + "static/media/clothes_active.1a5f883a.png";